import './polyfill';
import './app-initialization'; // First import for initial setup
import ScrollToTop from '@utils/ScrollToTop';
import { appConfig } from '@/config';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from '@/App';

const rootElement = document.getElementById('root') as Element;
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <ScrollToTop />
    </BrowserRouter>
  </React.StrictMode>,
);

console.log(`Running app version: v${appConfig.version}`);
